/**
 * The ITraceHubExServiceConnection provides an iterface for a single connectiojn to the TraceHub
 * connection - the connection object
 * connectionProxy - the proxy object for the hub for this connection
 * reconnect - bool -do we attempt a reconnect on a loss of connection that was not initiated but the user
 * @interface ITraceHubExServiceConnection
 */
angular
    .module('app')
    .factory('TraceHubExService', function ($rootScope, $log) {
    let connections = {};
    function connectWithSpecificTransport(componentName, transport) {
        let verbose = true;
        // See if we can locate the connection for this component, if not create it
        let connection = $.hubConnection('~/signalr');
        // NOTE: Switch on logging to see SignalR trace iconn console
        connection.logging = true;
        let proxy = connection.createHubProxy('traceHub');
        // NOTE: SignalR requires a method to be defined before we start up
        proxy.on('onInit', function () {
            $rootScope.$safeApply();
        });
        connection.connectionSlow(function () {
            // TODO: Swap for toastr
            $log.log('Slow connection to SignalR server');
        });
        connection.error(function (error) {
            // TODO: Swap for toastr
            $log.log('SignalR server connection error: ' + error);
        });
        if (!connections.hasOwnProperty(componentName)) {
            connections[componentName] = {
                connection: connection,
                connectionProxy: proxy,
                reconnect: true
            };
        }
        // NOTE: Auto reconnect unless we have stopped the service ourselves
        // Ref: http://stackoverflow.com/questions/23375043/best-practice-for-reconnecting-signalr-2-0-net-client-to-server-hub
        connection.disconnected(function () {
            setTimeout(function () {
                if (connections.hasOwnProperty(componentName)) {
                    // we have a connection, but process it if its state is 'disconnected' - 4
                    let hubConnection = connections[componentName];
                    if (hubConnection.connection.state && hubConnection.connection.state === 4) {
                        // Check if we should attempt a re-connection
                        if (!hubConnection.reconnect) {
                            // remove the connection from the collection if it exists
                            delete connections[componentName];
                            return;
                        }
                        // We need to attmept a re-connection
                        $log.log('SignalR reconnecting - ' + componentName);
                        hubConnection.connection
                            .start({ transport: transport.split(',') })
                            .done(function () {
                            $log.log('SignalR reconnected - ' + componentName);
                        });
                    }
                }
                else {
                    // no connection, must have already been removed - do nothing.
                    return;
                }
            }, 5000); // Restart connection after 5 seconds.
        });
        let disconnected = $.connection.hub.state ===
            $.signalR.connectionState.disconnected || true;
        let noHubState = $.connection.hub && !$.connection.hub.state;
        let isConnecting = false;
        // NOTE: Only start connection if we are not already connected
        // if ($.connection.hub && !$.connection.hub.state && $.connection.hub.state === $.signalR.connectionState.disconnected) {
        if (!isConnecting &&
            ((noHubState || disconnected) && connection.state === 4)) {
            isConnecting = true;
            connection
                .start({ transport: transport.split(',') })
                .done(function () {
                // See services/safe-apply for source
                // Ref: https://github.com/yearofmoo/AngularJS-Scope.SafeApply
                $rootScope.$safeApply();
                if (verbose) {
                    $log.log(`${componentName} connected to SignalR with transport = ${connection.transport.name} id: ${connection.id}`);
                }
                isConnecting = false;
            })
                .fail(function () {
                if (verbose) {
                    // remove the connection from the collection if it exists
                    if (!connections.hasOwnProperty(componentName)) {
                        delete connections[componentName];
                    }
                    $log.log('SignalR failed to start');
                }
                isConnecting = false;
            });
        }
        else {
            // We already have a connected connection for this component
            // so we need to call the OnConnected method on the hub
            // as it will trigger other client side updates that our component controllers will need
            proxy
                .invoke('clientConnectOnExistingConnection')
                .done(function () {
                $log.log('Invocation of OnConnected succeeded : ' +
                    componentName);
            })
                .fail(function (error) {
                $log.log('Invocation of OnConnected for ' +
                    componentName +
                    ' failed. Error: ' +
                    error);
            });
        }
    }
    function connect(componentName) {
        connectWithSpecificTransport(componentName, 'webSockets');
    }
    let fac = {
        connect: connect,
        connectWithSpecificTransport: connectWithSpecificTransport,
        connections: connections,
        on: function (componentName, eventName, callback) {
            let proxy = connections[componentName].connectionProxy;
            proxy.on(eventName, function (result) {
                $rootScope.$safeApply(function () {
                    if (callback) {
                        callback(result);
                    }
                });
            });
        },
        invoke: function (componentName, methodName, callback) {
            let proxy = connections[componentName].connectionProxy;
            proxy.invoke(methodName).done(function (result) {
                $rootScope.$safeApply(function () {
                    if (callback) {
                        callback(result);
                    }
                });
            });
        },
        invokeWithArgs: function (componentName, methodName, args, callback) {
            let proxy = connections[componentName].connectionProxy;
            proxy.invoke(methodName, ...args).done(function (result) {
                $rootScope.$safeApply(function () {
                    if (callback) {
                        callback(result);
                    }
                });
            }).fail(function (error) {
                $log.log(error);
            });
        },
        // NOTE: Called from angular controllers on $destroy
        // Ref: http://stackoverflow.com/questions/17813094/signalr-connection-freeze-other-ajax-requests
        stop: function (componentName) {
            let cnx = connections[componentName];
            if (cnx.connection) {
                cnx.reconnect = false;
                cnx.connection.stop();
                $log.log(componentName +
                    ' SignalR connection closed and reconnect set to ' +
                    cnx.reconnect);
                delete connections[componentName];
            }
        }
    };
    return fac;
});
